export class LoginInfo {
  public companyGuid: string;
  public email: string;
  public password: string;
  public hash: string;
  public testingFlag: string;
}
